import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'

export default function SkeletonInfos() {
  return (
    <SkeletonTheme>
      <Skeleton height={63} width={130} />
      <Skeleton height={108} />
      <Skeleton height={28} style={{ marginTop: 24 }} />
      <Skeleton count={6} height={28} />
      <Skeleton height={28} style={{ marginBottom: 24 }} />
      <Skeleton height={239} width={458} />
    </SkeletonTheme>
  );
}